<div class="filter-container">
  <!-- Filter Pills -->
  <finxone-web-frontend-finx-tags-container
    [filterOptions]="filterOptions"
    [filtersEnabled]="filtersEnabled"
    [filterMarginStyle]="filterMarginStyle"
    [attri]="attri"
    (filterChange)="onFilterPillChange($event)"
  ></finxone-web-frontend-finx-tags-container>

  <!-- Expanded Filter Context -->
  <div class="filter-content-panel" *ngIf="hasActiveFilters()">

    <!-- Date Filter Panel -->
    <div *ngIf="isFilterActive(TransactionFilterOptions.DATE)" class="filter-panel">
      <div class="date-range-container">
        <div class="date-inputs-row">
          <div class="date-input-wrapper">
            <finxone-datepicker
              [dateFormat]="datePickerTypes.DATEPICKER"
              [formControl]="fromDateControl"
              [placeholder]="'From Date'"
            ></finxone-datepicker>
          </div>
          <div class="date-input-wrapper">
            <finxone-datepicker
              [dateFormat]="datePickerTypes.DATEPICKER"
              [formControl]="toDateControl"
              [placeholder]="'To Date'"
            ></finxone-datepicker>
          </div>
        </div>
      </div>
    </div>

    <!-- Status Filter Panel -->
    <div *ngIf="isFilterActive(TransactionFilterOptions.STATUS)" class="filter-panel">
      <finxone-web-frontend-finx-tags-container
        [filterOptions]="statusOptions"
        [filtersEnabled]="true"
        [filterMarginStyle]="filterMarginStyle"
        [attri]="attri"
        (filterChange)="onSubFilterPillChange($event, TransactionFilterOptions.STATUS)"
      ></finxone-web-frontend-finx-tags-container>
    </div>

    <!-- Type Filter Panel -->
    <div *ngIf="isFilterActive(TransactionFilterOptions.TYPE)" class="filter-panel">
      <finxone-web-frontend-finx-tags-container
        [filterOptions]="typeOptions"
        [filtersEnabled]="true"
        [filterMarginStyle]="filterMarginStyle"
        [attri]="attri"
        (filterChange)="onSubFilterPillChange($event, TransactionFilterOptions.TYPE)"
      ></finxone-web-frontend-finx-tags-container>
    </div>

    <!-- Category Filter Panel -->
    <div *ngIf="isFilterActive(TransactionFilterOptions.CATEGORY)" class="filter-panel">
      <!-- Category options here -->
    </div>

    <!-- Tags Filter Panel -->
    <div *ngIf="isFilterActive(TransactionFilterOptions.TAGS)" class="filter-panel">
      <!-- Tags options here -->
    </div>
  </div>
</div>
